module.exports = __webpack_public_path__ + "static/media/bodiometer_logo.861e79b3.svg";